import { useState, useEffect, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import { HomePageSlider } from "./HomePageSlider";
const initialValues = {
  email: "",
};
export default function ForgotPassword() {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(false);
  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  // fix validation bug
  const validate = () => {
    let temp = {};
    temp.email = values.email !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  // form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(true);
      const formData = {
        email: values.email,
        domainUrl: window.location.origin,
      };
      try {
        const result = await apiService.post(config.SENDRESETLINK, formData);
        alert(result?.message);
      } catch (error) {
        console.error("Reset failed:", error);
      } finally {
        setBtnSubmit(false);
      }
    }
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" style={{ backgroundColor: "#F2F44E" }}></div>
      <div className="auth-page-content overflow-hidden mt-lg-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="card overflow-hidden rounded-4 loginbox shadow">
                      <div className="p-lg-5 p-4">
                        <h3 className="text-center">SMART ACCOUNTING</h3>
                        <p className="text-muted text-center">
                          Forgot Password
                        </p>
                        <form
                          onSubmit={handleSubmit}
                          autoComplete="off"
                          noValidate
                        >
                          <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              className={
                                "form-control" + applyErrorClass("email")
                              }
                              name="email"
                              type="text"
                              value={values.email}
                              onChange={handleInputChange}
                              placeholder="Enter Email"
                            />
                            {errors.email === false && (
                              <div className="validationerror">
                                Please enter email
                              </div>
                            )}
                          </div>
                          <div className="mt-4 d-flex justify-content-end">
                            {!btnSubmit ? (
                              <button
                                type="submit"
                                className="btn btn-success w-100 me-2"
                              >
                                Submit
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary w-100 me-2"
                                disabled
                              >
                                Please wait...
                              </button>
                            )}
                            <Link to="/" className="btn btn-danger me-2 w-100">
                              Back
                            </Link>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <HomePageSlider />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
